import React from "react";
import { RxCross1 } from "react-icons/rx";

const BundleRemovalWarningModal = ({
  open,
  onClose,
  onConfirm,
  itemName = "this item",
  warningText,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-xl">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-[18px] font-[600] text-[#1f2937]">Warning</h3>
          <button
            type="button"
            aria-label="Close warning"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full border border-slate-200 text-slate-600 transition hover:bg-slate-100"
          >
            <RxCross1 size={14} />
          </button>
        </div>

        <p className="text-[14px] leading-6 text-slate-700">
          Removing <span className="font-[600]">{itemName}</span> will break this bundle/offer.
          {warningText ? ` ${warningText}` : " Bundle pricing will be removed and affected prices will return to normal."}
        </p>

        <div className="mt-5 flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="h-[42px] flex-1 rounded-lg border border-slate-300 bg-white text-[14px] font-[600] text-slate-700 hover:bg-slate-50"
          >
            Keep Item
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="h-[42px] flex-1 rounded-lg bg-[#b42318] text-[14px] font-[600] text-white hover:bg-[#9b1f15]"
          >
            Remove Item
          </button>
        </div>
      </div>
    </div>
  );
};

export default BundleRemovalWarningModal;
